import { readable } from 'svelte/store';
import { getClient, query } from 'svelte-apollo';
import { gql } from 'apollo-boost';
const DEFAULT_REFRESH_INTERVAL = 60 * 60 * 1000; // 60min
const createStore = (graphQLQuery, responseVarName, refreshInterval = DEFAULT_REFRESH_INTERVAL) => readable([], function start(set) {
    const client = getClient();
    const parsedQuery = typeof graphQLQuery === 'string' ? gql(graphQLQuery) : graphQLQuery;
    const segments = query(client, { query: parsedQuery });
    async function refetch() {
        try {
            const { data } = await segments.refetch();
            if (data[responseVarName]) {
                set(data[responseVarName]);
            }
        }
        catch (err) {
            console.warn(`Error when refetching '${responseVarName}' store:`, err);
        }
    }
    refetch();
    const interval = setInterval(() => {
        refetch();
    }, refreshInterval);
    return function stop() {
        clearInterval(interval);
    };
});
export default createStore;
